import { useState } from "react";
import { Dialog } from "primereact/dialog";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";

interface ReferenceTimePickerDialogProps {
  isVisible: boolean;
  onHide: () => void;
  onConfirm: (referenceTime?: string) => void;
}

const ReferenceTimePickerDialog = ({
  isVisible,
  onHide,
  onConfirm,
}: ReferenceTimePickerDialogProps) => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  const handleConfirm = () => {
    const referenceTime = selectedDate
      ? selectedDate.toISOString()
      : undefined;
    onConfirm(referenceTime);
  };

  const handleHide = () => {
    setSelectedDate(null);
    onHide();
  };

  return (
    <Dialog
      header="Select Reference Time"
      visible={isVisible}
      style={{ width: "400px" }}
      onHide={handleHide}
      footer={
        <div className="flex justify-content-end gap-2">
          <Button
            label="Cancel"
            icon="pi pi-times"
            className="p-button-text"
            onClick={handleHide}
          />
          <Button
            label="Load"
            icon="pi pi-check"
            onClick={handleConfirm}
          />
        </div>
      }
    >
      <div className="flex flex-column gap-2">
        <label htmlFor="referenceTime">Reference time (optional)</label>
        <Calendar
          id="referenceTime"
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.value as Date | null)}
          showTime
          showSeconds
          hourFormat="24"
          showIcon
          showButtonBar
          dateFormat="yy-mm-dd"
          placeholder="Leave empty for latest"
        />
      </div>
    </Dialog>
  );
};

export default ReferenceTimePickerDialog;
